import { useGetShopDetails } from '../../services/core/shop';
import { getProvinceTaxGroup } from '../helpers/taxCalculation';

/**
 * The shop's province tax group (see PROVINCE_TAX_GROUP), resolved from its province/state code.
 * One place to read it, so every flow — create, edit, duplicate, conversion, detail — applies the
 * same Florida / Group-B / default tax + tooltip logic. Province groupings live in taxCalculation.js;
 * change the province lists there, not here.
 */
export const useProvinceTaxGroup = () => {
    const { data: shopDetails } = useGetShopDetails();
    const provinceCode = shopDetails?.province?.provinceCode ?? shopDetails?.provinceCode ?? '';
    return getProvinceTaxGroup(provinceCode);
};

export default useProvinceTaxGroup;
